import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { selectAllProposals, selectAllKeepOffers } from 'src/app/common/store/state/app.state';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { KeepOfferDialogComponent } from '../keep-offer-dialog/keep-offer-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TableDialogComponent } from 'src/app/public/common/components/table-dialog/table-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { CommonBasicData } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { Price } from 'src/app/public/common/models/string-data.model';
import { KeepBasicData } from '../../constants/keep-basic-data';
import { KeepOffer } from '../../models/keep-offer.model';

import { JobsComponent } from '../jobs/jobs.component';

@Component({
    selector: 'app-keep-offers',
    templateUrl: './keep-offers.component.html',
    styleUrls: ['./keep-offers.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatDatepickerModule, MatSelectModule, JobsComponent]
})
export class KeepOffersComponent {

  //@Input() proposals: Proposal[] = [];
  @Input() objectSource: ObjectSource = ObjectSource.PARK;
  @Input() businessLine: CarBusinessLine = CarBusinessLine.KEEP;
  @Input() carId: string = "";
  @Input() enableNew: boolean = false;

  keepOffers$: Observable<KeepOffer[]>;
  keepOffers: KeepOffer[] = [];

  ObjectSource = ObjectSource;
  CarBusinessLine = CarBusinessLine

  constructor(
      private router: Router,
      private store: Store, 
      public dialog: MatDialog) {
      this.keepOffers$ = this.store.select(selectAllKeepOffers(this.objectSource))
 
  }
     
  ngOnInit(): void {

    this.keepOffers$ = this.store.select(selectAllKeepOffers(this.objectSource))
          
    this.keepOffers$.subscribe(
      (result: KeepOffer[]) => this.keepOffers = result
    );

  }

   openKeepOfferDialog(offerId: string): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, offerId, 0, CarBusinessLine.KEEP );
    //objectData.carId = carId;

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(KeepOfferDialogComponent, {
      data: objectData
    });

  }

  /*
  openKeepOfferDialog(carId: string, businessLine: CarBusinessLine): void {
  
      let car: Car = new Car();
      car.businessLine = businessLine
      car.carId = carId
      car.country = this.currentDealer.countryResident
      //car.country = 
      //console.log(offer);
   
      const dialogRef = this.dialog.open(KeepOfferDialogComponent, {
        //data: Object.assign(new Car(), this.car)
        //data: structuredClone(this.car)
        data: structuredClone(car)
      });
  
      dialogRef.afterClosed().subscribe((result: any) => {
  
        if(result != undefined ){
          
          console.log(result)
          if(result.offerId === ''){
            console.log(result)
            this.store.dispatch(DealerActions.keepOfferNewSubmit({ keepOffer: result }));
          }
          else{
            this.store.dispatch(DealerActions.keepOfferUpdateSubmit({ keepOffer: result }));
          }
        }    
      });
    }
  
  
  openProposalDialog(proposalId: number, isReschedule: boolean): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.offerId, proposalId );

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: objectData
    });

    if(isReschedule){
      let instance = dialogRef.componentInstance
      instance.isReschedule = isReschedule
    }
  }

  
  openProposalDialogOld(prop?: Proposal): void {
  
      //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
      let proposal: Proposal;
  
      if(prop !== undefined){
        proposal = JSON.parse(JSON.stringify(prop!));
        //console.log('hello 1')
        
      }else{
        proposal = new Proposal();
        proposal.carId = this.carId!;
        //console.log('hello 2')
      }
  
      let isReschedule: boolean = (proposal.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited
  
      //console.log('prop = '+JSON.stringify(carId));
      const dialogRef = this.dialog.open(ProposalDialogComponent, {
        data: proposal
      });
      
      dialogRef.afterClosed().subscribe((result: Proposal) => {
  
        //console.log('helloo = '+JSON.stringify(result));
        
        if(result != undefined ){
  
          //console.log('New proposal = '+result.status+ " date = "+result.proposalDate+ " car Id = "+JSON.stringify(result));
          if(result.id === ''){
            console.log('new')
            this.store.dispatch(BuyActions.proposalNewSubmit ( { proposal: result }));
            return;
          }
  
          if(isReschedule){
            console.log('reschedule')
            this.store.dispatch(BuyActions.proposalRescheduleSubmit ( { proposalId: result.id, rescDate: result.rescheduleDate }));
            return;
          }
  
          else{
            console.log('update')
            this.store.dispatch(BuyActions.proposalUpdateSubmit ( { proposal: result }));          
            return;
          } 
        }  
      });
    }
  */

    deleteOffer(keepOfferId: string){
     this.store.dispatch(DealerActions.keepOfferDeleteSubmit( { keepOfferId: keepOfferId, objectSource: this.objectSource }));
    }

    toggleOfferPostedStatus(keepOfferId: string){
  
      console.log('heyy  po '+status.toString());
  
      this.store.dispatch(DealerActions.keepOfferTogglePostedSubmit ( { keepOfferId: keepOfferId, objectSource: this.objectSource }));
      
      console.log('heyy  po1 '+status.toString());
  
    }

    toggleOfferClosedStatus(keepOfferId: string){
  
      console.log('heyy cl  '+status.toString());
  
      this.store.dispatch(DealerActions.keepOfferToggleClosedSubmit ( { keepOfferId: keepOfferId, objectSource: this.objectSource }));
      console.log('heyy cl1  '+status.toString());
    }

    openPriceHistoryDialog(history: Price[], businessLine: CarBusinessLine): void {
    
        const dialogRef = this.dialog.open(TableDialogComponent, {
          data: {priceHistory: history, businessLine: businessLine, label: "Price"}
        });
    
        dialogRef.afterClosed().subscribe(() => {
      
        });
      }
  
    goToOfferPage(offerId: string, businessLine: CarBusinessLine): any{

      //console.log("navigate to "+offerId);
      this.router.navigate(
        ['/keep/'+businessLine.toString().toLowerCase()+'-offer'],
        { fragment: offerId }
      );
    }

    getServiceTypeTitle(code: string): string{
        return CommonBasicData.getServiceTypeTitle(code)!;
    }

    getJobCategoryTitle(code: string): string{
        return KeepBasicData.getCarJobCategoryTitle(code)!;
    }

    dateFormat(dt: string): string{
    
      return AppFunctions.stringToDatetime(dt);
    }

    moneyFormat(dt: string): string{
  
      return AppFunctions.numberWithComma(dt);
    }

}
